<template>
  <loader :is-loading="loading" color="primary"></loader>
</template>

<script>
export default {
  name: 'PaymentFailure',
  async beforeCreate() {
    this.loading = false;
    this.$store.dispatch('globalMessages/addError',
      { message: 'paymentOnboarding.errorTitle' });
    this.$router.push('/captures');
  },
  data() {
    return {
      loading: true,
    };
  },
};
</script>
